// Detects paragraph direction by finding the first "strong directional"
// character per Unicode Bidirectional Algorithm §P2/P3.
//
// RTL covers: Hebrew (0591-07FF), RTL control marks (200F, 202B, 202E),
//             Hebrew/Arabic presentation forms (FB1D-FDFD, FE70-FEFC).
// LTR covers: Basic Latin letters + Latin Extended A/B (00C0-02B8).
// Returns 'ltr' when no strong character is found (safe default).
// eslint-disable-next-line no-misleading-character-class
const RTL_RE = /[֑-߿‏‫‮יִ-﷽ﹰ-ﻼ]/u;
const LTR_RE = /[A-Za-zÀ-ÖØ-öø-ʸ]/u;
export function getTextDir(text) {
    for (const char of text) {
        if (RTL_RE.test(char))
            return "rtl";
        if (LTR_RE.test(char))
            return "ltr";
    }
    return "ltr";
}
